import type {TriggerRule} from 'src/types/trigger';

import {
  UPDATE_TRIGGER,
  ADD_TRIGGER_RULE,
  REMOVE_TRIGGER_RULE,
  UPDATE_TRIGGER_RULE,
  RECEIVE_TRIGGER,
  START_EDIT_TRIGGER_RULE,
  END_EDIT_TRIGGER_RULE,
  TOGGLE_POST_ACTIVATION_ONLY,
  TriggerAction,
} from 'src/action-creators/trigger';
import {getTriggerRule} from 'src/utils/trigger';


export type TriggerState = {
  rules: TriggerRule[];
  editRuleId: string | null | undefined;
  newlyAddedRuleId?: string | null | undefined;
  postActivationOnly: boolean;
};

const initialState = {
  rules: [],
  editRuleId: null,
  postActivationOnly: false,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly rules: readonly []; readonly editRuleId: null; readonly postActivationOnly: false; }' is not assignable to type 'TriggerState'.
  state: TriggerState | null | undefined = initialState,
  action: TriggerAction,
): TriggerState => {
  switch (action.type) {
    case ADD_TRIGGER_RULE: {
      const newTriggerRule = getTriggerRule({field: action.payload});
      // @ts-expect-error - TS2322 - Type '{ rules: TriggerRule[]; editRuleId: string; newlyAddedRuleId: string; postActivationOnly?: boolean | undefined; }' is not assignable to type 'TriggerState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        rules: [...state.rules, newTriggerRule],
        editRuleId: newTriggerRule.id,
        newlyAddedRuleId: newTriggerRule.id,
      };
    }
    case REMOVE_TRIGGER_RULE: {
      // @ts-expect-error - TS2322 - Type '{ rules: TriggerRule[]; editRuleId?: string | null | undefined; newlyAddedRuleId?: string | null | undefined; postActivationOnly?: boolean | undefined; }' is not assignable to type 'TriggerState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        rules: state.rules.filter((rule) => rule.id !== action.payload),
      };
    }
    case UPDATE_TRIGGER_RULE: {
      const {id, ...restPayload} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ rules: TriggerRule[]; editRuleId?: string | null | undefined; newlyAddedRuleId?: string | null | undefined; postActivationOnly?: boolean | undefined; }' is not assignable to type 'TriggerState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        rules: state.rules.map((rule) => {
          if (rule.id === id) {
            return {...rule, ...restPayload};
          }
          return rule;
        }),
      };
    }
    case RECEIVE_TRIGGER: {
      return {...state, ...action.payload};
    }
    case START_EDIT_TRIGGER_RULE: {
      // @ts-expect-error - TS2322 - Type '{ editRuleId: string; rules?: TriggerRule[] | undefined; newlyAddedRuleId?: string | null | undefined; postActivationOnly?: boolean | undefined; }' is not assignable to type 'TriggerState'.
      return {...state, editRuleId: action.payload};
    }
    case END_EDIT_TRIGGER_RULE: {
      // @ts-expect-error - TS2322 - Type '{ editRuleId: null; newlyAddedRuleId: null; rules?: TriggerRule[] | undefined; postActivationOnly?: boolean | undefined; }' is not assignable to type 'TriggerState'.
      return {...state, editRuleId: null, newlyAddedRuleId: null};
    }
    case TOGGLE_POST_ACTIVATION_ONLY: {
      // @ts-expect-error - TS2322 - Type '{ postActivationOnly: boolean; rules?: TriggerRule[] | undefined; editRuleId?: string | null | undefined; newlyAddedRuleId?: string | null | undefined; }' is not assignable to type 'TriggerState'. | TS18047 - 'state' is possibly 'null'.
      return {...state, postActivationOnly: !state.postActivationOnly};
    }
  }
  // @ts-expect-error - TS2322 - Type 'TriggerState | null' is not assignable to type 'TriggerState'.
  return state;
};
